import React from 'react'
import { DatePicker } from 'antd'
import type { Dayjs } from 'dayjs'

const { RangePicker } = DatePicker

export type DateRangeValue = [Dayjs | null, Dayjs | null] | null

export interface DateRangeFilterProps {
  value?: DateRangeValue
  onChange: (value: DateRangeValue) => void
  /** Disables dates outside `minDate`/`maxDate`. Pass those props to make the bound real. */
  bounded?: boolean
  minDate?: Dayjs
  maxDate?: Dayjs
  clearable?: boolean
  size?: 'small' | 'middle' | 'large'
  format?: string
  placeholder?: [string, string]
}

/**
 * The shared "pick a date window" filter, used by the report pages' Show row
 * (see docs/component-audit/datetime-pickers.html).
 */
export function DateRangeFilter({
  value,
  onChange,
  bounded = false,
  minDate,
  maxDate,
  clearable = true,
  size = 'middle',
  format = 'YYYY-MM-DD',
  placeholder,
}: DateRangeFilterProps) {
  const disabledDate = bounded
    ? (current: Dayjs) => {
        if (minDate && current.isBefore(minDate, 'day')) return true
        if (maxDate && current.isAfter(maxDate, 'day')) return true
        return false
      }
    : undefined

  return <RangePicker value={value} onChange={onChange} disabledDate={disabledDate} allowClear={clearable} size={size} format={format} placeholder={placeholder} />
}

export default DateRangeFilter
